export default __webpack_public_path__ + "static/media/maintenance_management_icon.a3a04f71.png";